import React from 'react';
import { Link } from 'react-router-dom';
import { allData as data } from '../data/data';
import { PortFolioStyles } from '../styles/portfolio.style';

const Portfolio = ({ index, onPopup }) => {
    return (
        <PortFolioStyles id="projects">
            <div className="container">
                <div className="row">
                    <div className="section__title">
                        <h2 data-heading="Portfolio">Latest Works</h2>
                    </div>
                </div>
                <div 
                    className="row portfolio__items"
                    onClick={(e) => onPopup(e)}
                >
                            {
                                data.map(project => (
                                    <div 
                                        className="portfolio__item" 
                                        key={project._id}
                                    >
                                        <div className="portfolio__item--inner outside-shadow">
                                            <div className="portfolio__item--img">
                                                <img src={project.homeImg} alt="furniture site project"
                                                />
                                                <span className="view__btn">View Project</span>
                                            </div>
                                            <p className="portfolio__item--title">{project.title}</p>
                                            <div className="portfolio__item--details">
                                                <div className="row">
                                                    <div className="description">
                                                        <h3>Project Summary:</h3>
                                                        <p>{project.details?.summary}</p>
                                                    </div>
                                                    <div className="info">
                                                        <ul>
                                                            <li>
                                                                Date - <span>{project.details?.projectInfo.date}</span>
                                                            </li>
                                                            <li>Client - <span>{project.details?.projectInfo.client}</span></li>
                                                            <li>tools - <span>{project.details?.projectInfo.tools.join(', ')}</span></li>
                                                            <li>
                                                                site - <span>
                                                                    <Link to={{pathname: `${project.details?.projectInfo.site}`}}
                                                                    target="_blank"
                                                                    >{project.details?.name}</Link>
                                                                </span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>    

                                ))
                            }
                </div>
            </div>
        </PortFolioStyles>
    )
}

export default Portfolio
